"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorLikeToDetails = exports.errorLikeToMessage = exports.toError = void 0;
const toError = (e) => {
    if (e instanceof Error) {
        return e;
    }
    return new Error(JSON.stringify(e));
};
exports.toError = toError;
const errorLikeToMessage = (e) => {
    const error = (0, exports.toError)(e);
    return `${error.constructor.name} [${error.name}]: ${error.message}`;
};
exports.errorLikeToMessage = errorLikeToMessage;
const errorLikeToDetails = (e) => {
    const error = (0, exports.toError)(e);
    return {
        type: error.constructor.name,
        name: error.name,
        message: error.message,
        stack: error.stack,
        cause: error.cause ? (0, exports.errorLikeToDetails)(error.cause) : undefined,
    };
};
exports.errorLikeToDetails = errorLikeToDetails;
